import React from 'react';
import { Field } from 'react-final-form';

import css from './FilterPreferredTime.module.css';

const TIME_OPTIONS = Array.from({ length: 24 * 4 }, (_, index) => {
  const totalMinutes = index * 15;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const value = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  const label = new Date(2000, 0, 1, hours, minutes).toLocaleTimeString('en-AU', {
    hour: 'numeric',
    minute: '2-digit',
  });

  return { value, label };
});

const FilterPreferredTime = () => (
  <div className={css.root}>
    <span className={css.icon} aria-hidden="true">◷</span>
    <Field name="preferredTime">
      {({ input }) => (
        <select
          {...input}
          className={css.input}
          aria-label="Preferred time"
          required
        >
          <option value="" disabled>
            Preferred time
          </option>
          {TIME_OPTIONS.map(({ value, label }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
      )}
    </Field>
  </div>
);

export default FilterPreferredTime;
